import { s } from '@/theme/tokens';
import { Inline } from '@/ui/layout/Inline';
import { PageHeader } from '@/ui/layout/PageHeader';
import { Section } from '@/ui/layout/Section';
import { Stack } from '@/ui/layout/Stack';
import { Box, PageShell } from '@/ui/primitives';
import type { SpacingToken } from '@/theme/tokens';
import type { ReactElement, ReactNode } from 'react';

type ListPageTemplateProps = {
  title: ReactNode;
  titleActions?: ReactNode;
  headerActions?: ReactNode;
  headerActionsMode?: 'inline' | 'separate';
  summary?: ReactNode;
  charts?: ReactNode;
  content?: ReactNode;
  footer?: ReactNode;
  paddingTop?: SpacingToken;
  paddingBottom?: SpacingToken;
};

export const ListPageTemplate = ({
  title,
  titleActions,
  headerActions,
  headerActionsMode = 'inline',
  summary,
  charts,
  content,
  footer,
  paddingTop = 'lg',
  paddingBottom = 'lg',
}: ListPageTemplateProps): ReactElement => (
  <PageShell
    maxWidth="xl"
    paddingX="lg"
    paddingY="xl"
    paddingTop={paddingTop}
    paddingBottom={paddingBottom}
  >
    <Stack gap="md">
      <Section paddingY="xxs">
        <Stack gap="md">
          <Box
            sx={
              headerActionsMode === 'separate' && headerActions
                ? { borderBottom: 1, borderColor: 'divider', pb: s('lg') }
                : undefined
            }
          >
            <PageHeader
              title={
                headerActionsMode === 'separate' ? (
                  title
                ) : (
                  <Inline gap="lg" align="center" wrap="wrap">
                    {title}
                    {titleActions}
                  </Inline>
                )
              }
              actions={headerActionsMode === 'separate' ? titleActions : headerActions}
            />
          </Box>
          {headerActionsMode === 'separate' && headerActions ? (
            <Box
              sx={{
                pt: s('sm'),
                pb: s('lg'),
                borderBottom: 1,
                borderColor: 'divider',
                width: '100%',
                display: 'flex',
                justifyContent: 'flex-end',
              }}
            >
              {headerActions}
            </Box>
          ) : null}
          {summary ? <Box sx={{ marginTop: s('md') }}>{summary}</Box> : null}
        </Stack>
      </Section>
      {charts ? <Box sx={{ marginTop: s('md') }}>{charts}</Box> : null}
      {content ? <Box sx={{ marginTop: s('lg') }}>{content}</Box> : null}
    </Stack>
    {footer}
  </PageShell>
);
